const NOW_SHOW_WHAT_IS_PHI_KEY = 'nowShowWhatIsPHI'

const STYLE = {
  width: '100%',
}

const DEBUG_STYLE = {
  border: '1px solid #FFBF00',
  width: '100%',
}

export interface IPHIComponent {
  isPHI?: boolean
}

export const getStyleForPHI = (isPHI = false) => {
  const debugFlag = localStorage.getItem(NOW_SHOW_WHAT_IS_PHI_KEY)

  if (isPHI && debugFlag === '1') {
    return DEBUG_STYLE
  }
  return STYLE
}
